import { Toast } from "antd-mobile";
import Axios from "axios";
import { ServiceUrl } from "../utils/serviceUrl";
import callApi from "../utils/callApi";
import { jsonToQuery } from "../utils";

export const listStudentTemplates = async () => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.UTILITIES.LIST_STUDENT_CERTIFICATES}`;
    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          Toast.show({ content: data["data"].message || "Error" });
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const getStudentTemplate = async (id) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.STUDENTS.GET_STUDENT_CERTIFICATE}?id=${id}`;
    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          Toast.show({ content: data["data"].message || "Error" });
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listSmsLogs = async (status = false) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.STUDENTS.STUDENT_SMS_LOGS}`;
    if (status) url = url + "?status=" + status;
    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          Toast.show({ content: data["data"].message || "Error" });
        }
        resolve({ data: data.data, count: data.count });
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listScholarships = async (status = false) => {
  return new Promise((resolve, reject) => {
    let url = `${ServiceUrl.UTILITIES.LIST_SCHOLARSHIPS}`;
    if (status) url = url + "?status=" + status;
    Axios.get(url)
      .then(function ({ data }) {
        if (data.status != "1") {
          Toast.show({ content: data["data"].message || "Error" });
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const _MY_TIME_TABLE = async (searchData = false) => {
  let url = ServiceUrl.MOB.MY_TIME_TABLE;
  return callApi(url, "post", searchData && searchData);
};

export const _ListHourPerDay = async (searchData = false) => {
  let url = ServiceUrl.MOB.LIST_HOUR_PER_DAY;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _ListHourPerDayMob = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.LIST_HOUR_PER_DAY;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};
